import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const IconArrowNext = (props:any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={26} height={25} {...props} style={props.style}>
    <Path
      fill={props.fill ? props.fill : '#fff'}
      d="M10.906 1.674a1.366 1.366 0 0 0 .023 1.964l6.9 6.572H1.375a1.371 1.371 0 0 0-1.374 1.374v1.832a1.371 1.371 0 0 0 1.374 1.374h16.452l-6.9 6.572a1.375 1.375 0 0 0-.023 1.964l1.271 1.27a1.368 1.368 0 0 0 1.941 0l11.13-11.129a1.368 1.368 0 0 0 0-1.941L14.117.403a1.368 1.368 0 0 0-1.941 0Z"
    />
  </Svg>
);
export default IconArrowNext;
